var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapSize},[(_vm.label)?_c('div',{class:_vm.labelWrap},[_c('label',{staticClass:"inline-block text-80 leading-tight",attrs:{"for":_vm.labelFor}},[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }